// store.js
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { combineReducers } from 'redux';  // Import combineReducers
import { homeReducer } from './Components/Home/Reducer';
import { watchFetchHome } from './Components/Home/Saga';
import { watchFetchLogin } from './Components/Login/Saga';
import { loginReducer } from './Components/Login/Reducer';
import { familyTreeReducer } from './Components/FamilyTree/Reducer';
import { watchFetchFamilyTree } from './Components/FamilyTree/Saga';
import { appointmentsListReducer } from './Components/Appointment/Reducer';
import { watchFetchAppointmentsList } from './Components/Appointment/Saga';
import { healthRecordReducer } from './Components/HealthRecord/Reducer';
import { watchFetchHealthRecords } from './Components/HealthRecord/Saga';
import { prescriptionReducer } from './Components/Prescription/Reducer';
import { watchFetchPrescriptions } from './Components/Prescription/Saga';
import { checkupsReducer } from './Components/MyCheckups/Reducer';
import { watchFetchCheckups } from './Components/MyCheckups/Saga';
import { myProfileReducer } from './Components/ProfileFront/Reducer';
import { watchFetchMyProfile } from './Components/ProfileFront/Saga';
import { passportReducer } from './Components/Passport/Reducer';
import { watchFetchPassport } from './Components/Passport/Saga';
import { doctorListReducer } from './Components/DoctorListing/Reducer';
import { watchFetchDoctorListing } from './Components/DoctorListing/Saga';
import { timeSlotReducer } from './Components/SelectTimeSlot/Reducer';
import { watchFetchTimeSlot } from './Components/SelectTimeSlot/Saga';
import { selectLocationReducer } from './Components/SelectLocation/Reducer';
import { watchFetchSelectLocation } from './Components/SelectLocation/Saga';
import { ondemandReducer } from './Components/Ondemand/Reducer';
import { watchFetchOndemand } from './Components/Ondemand/Saga';
import { planMySurgeryReducer } from './Components/PlanMySurgery/Reducer';
import { watchFetchPlanMySurgery } from './Components/PlanMySurgery/Saga';
import { deleteAccountReducer } from './Components/DeleteAccount/Reducer';
import { watchFetchDeleteAccount } from './Components/DeleteAccount/Saga';
import { registerReducer } from './Components/Register/Reducer';
import { watchFetchRegister } from './Components/Register/Saga';
import { forgotPasswordReducer } from './Components/ForgotPassword/Reducer';
import { watchFetchForgotPassword } from './Components/ForgotPassword/Saga';
import  doctorReducer  from './Components/DoctorCampaign/reducer';
import { doctorCampaignWatcher } from './Components/DoctorCampaign/Saga';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Combine the reducers into a single rootReducer
const rootReducer = combineReducers({
    home: homeReducer,
    login: loginReducer,
    familyTree: familyTreeReducer,
    appointmentsList : appointmentsListReducer,
    healthRecord : healthRecordReducer,
    prescription : prescriptionReducer,
    checkups : checkupsReducer,
    myProfile : myProfileReducer,
    passport : passportReducer,
    doctorList : doctorListReducer,
    timeSlot : timeSlotReducer,
    selectLocation : selectLocationReducer,
    ondemand : ondemandReducer,
    planMySurgery : planMySurgeryReducer,
    deleteAccount : deleteAccountReducer,
    register : registerReducer,
    forgotPassword : forgotPasswordReducer,
    doctorCampaign : doctorReducer
});

// Create the Redux store with the rootReducer
const store = createStore(
    rootReducer, // Pass the combined rootReducer here
    applyMiddleware(sagaMiddleware) // Apply the saga middleware
);

// Run the saga middleware
sagaMiddleware.run(watchFetchHome);
sagaMiddleware.run(watchFetchLogin);
sagaMiddleware.run(watchFetchFamilyTree);
sagaMiddleware.run(watchFetchAppointmentsList);
sagaMiddleware.run(watchFetchHealthRecords);
sagaMiddleware.run(watchFetchPrescriptions);
sagaMiddleware.run(watchFetchCheckups);
sagaMiddleware.run(watchFetchMyProfile);
sagaMiddleware.run(watchFetchPassport);
sagaMiddleware.run(watchFetchDoctorListing);
sagaMiddleware.run(watchFetchTimeSlot);
sagaMiddleware.run(watchFetchSelectLocation);
sagaMiddleware.run(watchFetchOndemand);
sagaMiddleware.run(watchFetchPlanMySurgery);
sagaMiddleware.run(watchFetchDeleteAccount);
sagaMiddleware.run(watchFetchRegister);
sagaMiddleware.run(watchFetchForgotPassword);
sagaMiddleware.run(doctorCampaignWatcher);

export default store;
